import { ArrowRightIcon, BusIcon } from "assets/icons";

function SearchCard() {
  return (
    <div className="w-full max-w-[490px] bg-white shadow-block px-4 lg:px-6 py-6 lg:py-8 flex items-center rounded-[15px]">
      <div className="text-primary-700 mr-5">
        <BusIcon />
      </div>
      <div className="flex-1 flex gap-3 md:gap-6">
        <div className="flex flex-col">
          <div className="text-sm md:text-lg font-semibold text-[#263238]">
            Kuala Lumpur
          </div>
          <div className="text-sm md:text-lg font-medium text-[#858585]">
            Sun, 12 May
          </div>
        </div>
        <div className="h-[18px] w-[18px] text-[#858585] mt-1.5">
          <ArrowRightIcon />
        </div>
        <div className="flex flex-col">
          <div className="text-sm md:text-lg font-semibold text-[#263238]">
            Johor Bahru
          </div>
        </div>
      </div>
    </div>
  );
}
export default SearchCard;
